import './TextButton.scss'

interface Props {
    onClick?: () => void
    label: String
    iconClassName?: String
    disabled?: boolean
}
const TextButton = (props: Props) => {
    return (
        <button className="text-button" onClick={props.onClick} disabled={props.disabled}>
            {Boolean(props.iconClassName) && <i className={`cu ${props.iconClassName}`}></i>}
            <span>{props.label}</span>
        </button>
    )
}

export default TextButton
